<template>
  <div class="relative px-4 sm:px-6 pt-6 pb-16 md:pb-20 lg:pb-24 xl:pb-32">
    <div class="z-10 lg:grid lg:grid-cols-12 lg:gap-8">
      <div class="sm:text-center md:max-w-2xl md:mx-auto lg:col-span-6 lg:text-left">
        <div class="text-sm font-semibold uppercase tracking-wide text-gray-500 sm:text-base lg:text-sm xl:text-base">
          Coming soon
        </div>

        <div class="inline-flex flex-col text-red-600 justify-end">
          <h1 class="font-extrabold leading-none sm:text-7xl text-6xl text-right tracking-tight">Snowman</h1>
          <p class="-mt-1.5 font-medium leading-none text-right text-xl">PRO</p>
        </div>

        <h2 class="mt-10 text-4xl tracking-tight leading-10 font-extrabold text-gray-900 sm:leading-none sm:text-6xl lg:text-5xl xl:text-6xl">
          Snow and ice management
          <br class="hidden md:inline" />
          <span class="text-red-600">for the front line</span>
        </h2>
        <p class="mt-3 text-base text-gray-500 sm:mt-5 sm:text-xl lg:text-lg xl:text-xl">
          A management app by snow professionals, for snow professionals.
        </p>
        <div class="mt-10 sm:max-w-lg sm:mx-auto sm:text-center lg:text-left lg:mx-0">
          <p class="text-base font-medium text-gray-900">
            Sign up to get notified when it's ready.
          </p>
          <form action="https://snowmanpro.us19.list-manage.com/subscribe/post?u=dcda1bd6f47ac08dda6c53476&amp;id=e2e21a952f" method="POST" class="mt-3 sm:flex" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" target="_blank" novalidate>
            <input aria-label="Email" name="EMAIL" id="mce-EMAIL" class="appearance-none block w-full px-3 py-3 border border-gray-300 text-base leading-6 rounded-md placeholder-gray-500 shadow-sm focus:outline-none focus:placeholder-gray-400 focus:shadow-outline focus:border-blue-300 transition duration-150 ease-in-out sm:flex-1" placeholder="Enter your email" />
            <div style="position: absolute; left: -5000px;" aria-hidden="true"><input type="text" name="b_dcda1bd6f47ac08dda6c53476_e2e21a952f" tabindex="-1" value=""></div>
            <button type="submit" class="mt-3 w-full px-6 py-3 border border-transparent text-base leading-6 font-medium rounded-md text-white bg-gray-800 shadow-sm hover:bg-gray-700 focus:outline-none focus:shadow-outline active:bg-gray-900 transition duration-150 ease-in-out sm:mt-0 sm:ml-3 sm:flex-shrink-0 sm:inline-flex sm:items-center sm:w-auto">
              Notify me
            </button>
          </form>
          <p class="mt-3 text-sm leading-5 text-gray-500">
            We care about the protection of your data. Read our
            <a href="#" class="font-medium text-gray-900 underline">Privacy Policy</a>.
          </p>
        </div>
      </div>
      <div class="mt-12 relative sm:max-w-lg sm:mx-auto lg:mt-0 lg:max-w-none lg:mx-0 lg:col-span-6 lg:flex lg:items-center">
        <div class="relative mx-auto w-full rounded-lg shadow-lg lg:max-w-md">
          <button class="relative block w-full rounded-lg overflow-hidden focus:outline-none focus:shadow-outline">
            <!--
              Image sourced from Wikimedia Commons (https://commons.wikimedia.org/wiki/File:Snow_removal_13.jpg)
              Author: Gillfoto (https://commons.wikimedia.org/wiki/User:Gillfoto)
              License: CC-BY-4.0 (https://creativecommons.org/licenses/by-sa/4.0/deed.en)
             -->
            <img class="w-full" src="/Snow_removal_13.jpg" alt="A man using a snowblower and a man with a shovel" />
            <!-- <img class="w-full" src="https://images.unsplash.com/photo-1551930139-333de680709a?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80" alt="Man looking at his phone during a snowstorm" /> -->

            <!-- <div class="absolute inset-0 w-full h-full flex items-center justify-center">
              <svg class="h-20 w-20 text-red-500" fill="currentColor" viewBox="0 0 84 84">
                <circle opacity="0.9" cx="42" cy="42" r="42" fill="white" />
                <path d="M55.5039 40.3359L37.1094 28.0729C35.7803 27.1869 34 28.1396 34 29.737V54.263C34 55.8604 35.7803 56.8131 37.1094 55.9271L55.5038 43.6641C56.6913 42.8725 56.6913 41.1275 55.5039 40.3359Z" />
              </svg>
            </div> -->

          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {

      }
    }
  }
</script>
